import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Icon from '../../../commons/Icon'

export const Breadcrumb = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  margin: 1rem 0;
`

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  &:not(:last-of-type)::after {
    content: '';
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 1rem;
    background: url('/assets/images/icon-breadcrumb.svg') center / cover no-repeat;
  }
`

export const BreadcrumbHome = styled(Link)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.mono.greyDark};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`

export const BreadcrumbIcon = styled(Icon)`
  width: 2rem;
  height: 2rem;
`

export const BreadcrumbParent = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.lg};
  color: ${({ theme }) => theme.colors.primary.default};
`

export const BreadcrumbParentLink = styled(Link)`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.mono.black};
  }
`

export const BreadcrumbActive = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.primary.greyDarker};
`
